import React, { useEffect, useState } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { buttonLinkStyle } from "../../admin/StudySetup/Visits/Questionnaires/EditVisitQuestionnaire";
import { Col, Row } from "react-bootstrap";
import { Card, CardContent, CardMedia } from "@mui/material";
import studyImage from "../../../assets/admin/studies_1.png";
import { useLocation, useNavigate } from "react-router";
import { getAllUserStudiesService } from "../../../services/sponsors";
import { rowStyles } from "../../admin/StudySetup/SubjectAttributes/SubjectAttributes";
import settings from "../../../assets/sponsors/setting.png";

const UserStudies = () => {
  const [load, setLoad] = useState(false);
  const [studiesData, setStudisData] = useState([]);

  const location = useLocation();
  const sponsorId = location?.state?.id;
  const userId = localStorage?.getItem("userId");
  const access_token = localStorage?.getItem("token");

  useEffect(() => {
    if (!access_token) {
      navigate("/login");
    }
  }, [access_token]);

  const navigate = useNavigate();

  useEffect(() => {
    if (userId && sponsorId) {
      getUserStudies(userId, sponsorId);
    }
  }, [userId, sponsorId]);

  const getUserStudies = async (userId, sponsorId) => {
    setLoad(true);
    try {
      const res = await getAllUserStudiesService(userId, sponsorId);
      if (res?.status == 200) {
        setLoad(false);
        setStudisData(res?.data?.result);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message);
    }
  };

  return (
    <>
      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <BeatLoader color="#3661eb" />
        </div>
      ) : (
        <div className="content-body">
          <p className="admin-link" style={{ fontWeight: "600" }}>
            <button style={buttonLinkStyle}>User Studies</button>
          </p>
          <div style={{ marginTop: "30px" }}>
            <Row xl={6} lg={6} md={6} sm={12} xs={12}>
              {studiesData &&
                studiesData?.map((item, index) => (
                  <Col
                    key={index}
                    xl={4}
                    lg={2}
                    md={6}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: "20px" }}
                  >
                    <Card sx={{ maxWidth: 200 }}>
                      <CardMedia
                        component="img"
                        alt="card-image"
                        className="fluid-image"
                        sx={{
                          height: "90px",
                          width: "100%",
                          objectFit: "contain",
                          padding: "10px",
                        }}
                        image={studyImage}
                      />
                      <CardContent>
                        {/* Ensure full width and use space between */}
                        <div
                          style={{
                            textAlign: "center",
                            marginTop: "20px",
                          }}
                        >
                          <button
                            style={buttonLinkStyle}
                            onClick={() => {
                              let newUrl = "";
                              if (
                                item?.portalUrl?.startsWith("https://") ||
                                item?.portalUrl?.startsWith("http://")
                              ) {
                                newUrl = `${
                                  item?.portalUrl
                                }?token=${access_token}&studyName=${encodeURIComponent(
                                  item?.studyName
                                )}`;
                              } else {
                                newUrl = `https://${
                                  item?.portalUrl
                                }?token=${access_token}&studyName=${encodeURIComponent(
                                  item?.studyName
                                )}`;
                              }

                              // Open the link with the data in the URL query string
                              window.open(
                                newUrl,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          >
                            {item?.studyName}
                          </button>
                          {/* <button
                            style={{ ...buttonLinkStyle, marginLeft: "auto" }}
                            onClick={() => {
                              let newUrl = `${
                                item?.questionnaireBuilderUrl
                              }?studyName=${encodeURIComponent(
                                item?.studyName
                              )}`;
                              window.open(
                                newUrl,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          >
                            <img
                              src={settings}
                              alt="settings-img"
                              style={{
                                height: "25px",
                                width: "auto",
                              }}
                            />
                          </button> */}
                        </div>
                      </CardContent>
                    </Card>
                  </Col>
                ))}
            </Row>
          </div>
          <Row style={rowStyles}>
            <Col md={10}></Col>
            <Col md={2}>
              <div className="study-management-head-end">
                <button
                  onClick={(e) => {
                    navigate("/sponsors-studies");
                  }}
                  className="study-management-cancel-btn"
                >
                  Back
                </button>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default UserStudies;
